import React from 'react';
import Reflux from 'reflux';

import MaintenanceStore from 'flux/stores/MaintenanceStore';

/**
 * Shows the maintenance curtain when the site is undergoing maintenance
 */
export default React.createClass({
  mixins: [Reflux.connect(MaintenanceStore, 'enabled')],

  displayName: 'MaintenanceCurtain',

  // eslint-disable-next-line react/display-name
  render: function () {
    if (!this.state.enabled) return null;
    return (
      <div id="maint-curtain-outer">
        <img
          id="maint-curtain-logo"
          src={`${window.shofloAssetBaseUrl}/logo.png`}
        />

        <div id="maint-curtain-inner">
          <img
            id="maint-curtain-graphic"
            src={`${window.shofloAssetBaseUrl}/img/maintenance_graphic.svg`}
          />
          <h2>Shoflo is currently undergoing maintenance</h2>
          <p>
            Shoflo is currently performing scheduled maintenance and is
            unavailable for use. We are working as quickly as possible and this
            alert will disappear when the maintenance is finished.
          </p>
        </div>
      </div>
    );
  },
});
